/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ready: NonNullable<unknown>, min: NonNullable<unknown> }} Portals_Check_PhotosInputs */

const cs_portals_check_photos = /** @type {(inputs: Portals_Check_PhotosInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fotografie: ${i?.ready} / ${i?.min} ready`)
};

const en_portals_check_photos = /** @type {(inputs: Portals_Check_PhotosInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Photos: ${i?.ready} / ${i?.min} ready`)
};

/**
* | output |
* | --- |
* | "Photos: {ready} / {min} ready" |
*
* @param {Portals_Check_PhotosInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_check_photos = /** @type {((inputs: Portals_Check_PhotosInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Check_PhotosInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_check_photos(inputs)
	return cs_portals_check_photos(inputs)
});